import React, { FC } from 'react';

import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Skeleton from '@mui/material/Skeleton';

type Props = {
  cols: number;
  rows?: number;
  hideToolbar?: boolean;
};

const TableSkeleton: FC<Props> = ({ cols, rows = 5, hideToolbar = false }) => (
  <Box>
    {!hideToolbar && (
      <Box sx={{ display: 'flex' }}>
        <Skeleton variant="circular" width={40} height={40} />
        <Box sx={{ flexGrow: 1 }}></Box>
        <Skeleton width={200} sx={{ mr: 2 }} />
        <Skeleton width={200} />
      </Box>
    )}

    <Table>
      <TableHead>
        <TableRow>
          {Array(cols)
            .fill(0)
            .map((_, i) => (
              <TableCell key={i}>
                <Skeleton height={30} />
              </TableCell>
            ))}
        </TableRow>
      </TableHead>

      <TableBody>
        {Array(rows)
          .fill(0)
          .map((_, i) => (
            <TableRow key={i}>
              {Array(cols)
                .fill(0)
                .map((_, i) => (
                  <TableCell key={i}>
                    <Skeleton />
                  </TableCell>
                ))}
            </TableRow>
          ))}
      </TableBody>
    </Table>
  </Box>
);

export default TableSkeleton;
